<template>
    <div>
        <div class="row form-group">
            <h2 class="title-2 col-md-6 header-title">Import Evaluations</h2>
        </div>
        <div class="card">
            <div class="card-body form-group">
                <input
					type="file"
					id="file-input"
					name="file-input"
					ref="inputFile"
					class="form-control-file"
					@change="onFileChange(...arguments)"
				/>
                <br />
                <button id="submit" @click="upload()" class="btn btn-outline-success btn-success mr-2">
                    Import Data
                </button>
				<br/>
				<br/>
				<div class="row form-group">
						<button @click="dowloadData()" class=" btn btn-outline-primary" id="data-backup"><i
								class="fas fa-download"></i> Download Data Backup</button>
				</div>

                <!-- <a class="btn btn-warning" href="javascript:;" @click="exportData()">Export Data</a> -->
            </div>
        </div>
    </div>
</template>
<script>
import {saveAs} from 'file-saver';
export default {
	data: () => ({
	    selectedFile: []
	}),
	methods: {
        onFileChange(e) {
			var files = e.target.files || e.dataTransfer.files;
			if (!files.length) {
				return;
			}
			this.selectedFile = [];
			Array.prototype.forEach.call(files, item => {
				this.selectedFile.push(item);
			});
		},
		exportData(){
			this.axios.get("/get_upload_evaluations_file.php").then((response) => {
				let a = document.createElement("a"); //Create <a>
				a.href = response.data.data.file;
				a.download = response.data.data.name;
				a.click();
			});
		},
		upload() {
			let _vm = this;
			let fd = new FormData();
            if(this.selectedFile.length==0){
                this.$dialog
				.confirm("Please select file first!");
                return;
            }
			fd.append("file", this.selectedFile[0]);
			this.axios.post("/set_import_evaluations.php", fd).then(() => {
				_vm.selectedFile = [];
				//_vm.$refs.inputFile.reset();
				$("#file-input").val('');
				document.getElementById("file-input").value = "";
			});
		},
		dowloadData(){
			this.axios.get("/set_export_data.php",{responseType: 'blob'})
			.then((response) => {
				saveAs(response.data, 'EvaluatorDataBackup.zip');
				// console.log('response: ' .response);
				// let a = document.createElement("a"); //Create <a>
				// a.href = response.data.data.file;
				// a.download = response.data.data.name;
				// a.click();
			});
		},

    }
};

</script>

